import { render, staticRenderFns } from "./uf_name.vue?vue&type=template&id=c52b9f92&scoped=true"
import script from "./uf_name.vue?vue&type=script&lang=js"
export * from "./uf_name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b9f92",
  null
  
)

export default component.exports